/**
 * Created by Administrator on 2018/5/10.
 */
import { quesSignSave } from '../../api/evaluation'

const getSignResult = (signFile, vm) => {
  let data = {
    sysCode: vm.params.sysCode,
    managerAdminUserId: vm.params.managerId,
    userId: vm.params.invenstemUserId,  // 理财师添加的用户ID
    platformUserId: vm.params.platformUserId,
    evaluationResultFile: vm.params.evaluationResultFile,
    signImagesFileInfo: signFile
  }
  console.log('合成签名提交的数据：', data)
  vm.$vux.loading.show({text: '签名合成中'})
  quesSignSave(data, vm.params.au).then((res) => {
    vm.$vux.loading.hide()
    if (res.code === 0) {
      console.log('签章合成返回', res)
      vm.params.evaluationResultFileSign = res.data.bean.evaluationResultFileSign
      vm.$vux.toast.show({text: '签署成功', type: 'success'})
      switchRouter(vm)
    } else {
      vm.$vux.toast.show({text: res.msg, type: 'warn'})
    }
  }).catch(e => {
    this.$vux.loading.hide()
    this.$vux.toast.show({text: '服务器繁忙, 请重试', type: 'warn'})
    return Promise.reject(e)
  })
}

const switchRouter = (vm) => {
  console.log('风险测评签署跳转数据', vm)
  let re = vm.params.re
  if (re === 1) {           // 最低风险等级
    vm.$router.push({path: '/evaluation/lastlowend', query: vm.params})
    return
  }
  if (re === 2) {             // 正常情况
    vm.$router.push({path: '/evaluation/normal', query: vm.params})
    return
  }
  if (re === 3) {              // 比原等级低
    vm.$router.push({path: '/evaluation/batchlow', query: vm.params})
  }
}

const signPdf = (vm) => {
  let isNeedSign = parseInt(vm.params.isNeedSign)
  if (isNeedSign === 1) {
    vm.$bridge.registerHandler('getSignData', (data) => {
      getSignResult(data, vm)
    })
    vm.$bridge.callHandler('sign', {message: '用户签名', userId: vm.params.userId}, (data) => {})
  }
}

export default signPdf



// WEBPACK FOOTER //
// ./src/components/Evaluation/signHandle.js